import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import {InicioComponent} from './secciones/inicio/inicio.component';
import { NosotrosComponent } from './secciones/nosotros/nosotros.component';
import { NeuroakashicoComponent } from './secciones/neuroakashico/neuroakashico.component';
import { TiendaComponent } from './secciones/tienda/tienda.component';
import { DirectorioComponent } from './secciones/directorio/directorio.component';
import { CalendarioComponent } from './secciones/calendario/calendario.component';
import { RadioGaleriaComponent } from './secciones/radio-galeria/radio-galeria.component';
import { NinosComponent } from './secciones/ninos/ninos.component';
import { CongresoVirtualComponent } from './secciones/congreso-virtual/congreso-virtual.component';
import { DisfrutaBeneficiosComponent } from './componentes/disfruta-beneficios/disfruta-beneficios.component';
import { ContactoComponent } from './secciones/contacto/contacto.component';


import { Aa2Component } from './cursos/aa2/aa2.component';
import { AacComponent } from './cursos/aac/aac.component';
import { AaliComponent } from './cursos/aali/aali.component';
import { CaComponent } from './cursos/ca/ca.component';
import { CnComponent } from './cursos/cn/cn.component';
import { ExpComponent } from './cursos/exp/exp.component';
import { NagoComponent } from './cursos/nago/nago.component';
import { NagsComponent } from './cursos/nags/nags.component';
import { P21esComponent } from './cursos/p21es/p21es.component';
import { SrnComponent } from './cursos/srn/srn.component';
import { Te2020Component } from './cursos/te2020/te2020.component';
import { P21sComponent } from './cursos/p21s/p21s.component';
import { NgoComponent } from './cursos/ngo/ngo.component';
import { CicloMeditacionesComponent } from './secciones/ciclo-meditaciones/ciclo-meditaciones.component';





const routes: Routes = [
  {path:'', component: InicioComponent},
  {path:'inicio', component: InicioComponent},
  {path:'nosotros', component: NosotrosComponent},
  {path:'neuroakashico', component: NeuroakashicoComponent},
  {path:'tienda', component: TiendaComponent},
  {path: 'directorio', component: DirectorioComponent},
  {path: 'calendario', component: CalendarioComponent},
  {path: 'radio-galeria', component: RadioGaleriaComponent},
  {path: 'ninos', component: NinosComponent},
  {path: 'congreso-virtual', component: CongresoVirtualComponent},
  {path: 'beneficios', component: DisfrutaBeneficiosComponent},
  {path: 'contacto', component: ContactoComponent},
  {path: 'ciclo_meditaciones_21_dias', component: CicloMeditacionesComponent},

  {path: 'curso/aa2', component: Aa2Component},
  {path: 'curso/aac', component: AacComponent},
  {path: 'curso/aali', component: AaliComponent},
  {path: 'curso/ca', component: CaComponent},
  {path: 'curso/cn', component: CnComponent},
  {path: 'curso/exp', component: ExpComponent},
  {path: 'curso/nago', component: NagoComponent},
  {path: 'curso/nags', component: NagsComponent},
  {path: 'curso/p21es', component: P21esComponent},
  {path: 'curso/srn', component: SrnComponent},
  {path: 'curso/te2020', component: Te2020Component},
  {path: 'curso/p21s', component: P21sComponent},
  {path: 'curso/ngo', component: NgoComponent},
  

  
  
  


];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
